<template>
  <b-sidebar
    id="add-new-customer-sidebar"
    :visible="customerAddSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(visible) => $emit('update:customer-add-sidebar-active', visible)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Nuevo Cliente
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <validation-observer ref="simpleRules">
        <b-form
          class="p-2"
          @submit.prevent="onSubmit"
          @reset.prevent="onReset"
        >
          <!-- Información General -->
          <h4 class="mb-2">
            <feather-icon
              icon="UserIcon"
              size="18"
              class="mr-1"
            />
            Información General
          </h4>
          <b-row>
            <b-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                name="cliente"
                rules="required"
              >
                <b-form-group
                  label="Cliente:"
                  label-for="input-name"
                >
                  <b-form-input
                    id="input-name"
                    v-model="form.name"
                    placeholder="Ingresa el nombre del cliente"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="nit"
                rules="required"
              >
                <b-form-group
                  label="NIT:"
                  label-for="input-nit"
                >
                  <b-form-input
                    id="input-nit"
                    v-model="form.nit"
                    placeholder="Ingresa el NIT"
                    required
                    @change="changeNit"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="nombre del nit"
                rules="required"
              >
                <b-form-group
                  label="Nombre del NIT:"
                  label-for="input-nit_name"
                >
                  <b-form-input
                    id="input-nit_name"
                    v-model="form.nit_name"
                    placeholder="Ingresa el nombre del NIT"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <!-- Información de Contacto -->
          <h4 class="mb-2 mt-1">
            <feather-icon
              icon="PhoneIcon"
              size="18"
              class="mr-1"
            />
            Información de Contacto
          </h4>

          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Número de celular"
                label-for="input-cellphone"
              >
                <cleave
                  id="input-cellphone"
                  v-model="form.cellphone"
                  class="form-control"
                  :raw="false"
                  :options="options.cellphoneDelimiter"
                  placeholder="Número de celular"
                />
              </b-form-group>

              <b-form-group
                label="Número de teléfono"
                label-for="input-phone"
              >
                <cleave
                  id="input-phone"
                  v-model="form.phone"
                  class="form-control"
                  :raw="false"
                  :options="options.cellphoneDelimiter"
                  placeholder="Número de teléfono"
                />
              </b-form-group>

              <validation-provider
                v-slot="{ errors }"
                name="correo"
                rules="email"
              >
                <b-form-group
                  label="Correo:"
                  label-for="input-email"
                >
                  <b-form-input
                    id="input-email"
                    v-model="form.email"
                    placeholder="Ingresa el correo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="origen"
                rules="required"
              >
                <b-form-group
                  label="Origen:"
                  label-for="input-origin"
                >
                  <b-form-select
                    id="input-origin"
                    v-model="form.origin"
                    :options="originOptions"
                    placeholder="Selecciona el origen del cliente"
                    required
                  />
                  <small class="text-muted">¿Cómo fue captado este cliente?</small>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="tipo de cliente"
              >
                <b-form-group
                  label="Tipo de cliente:"
                  label-for="input-customer-type"
                >
                  <b-form-select
                    id="input-customer-type"
                    v-model="form.customer_type"
                    :options="customerTypeOptions"
                    placeholder="Selecciona el tipo de cliente"
                  />
                  <small class="text-muted">Clasificación del cliente</small>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <!-- Configuración Comercial -->
          <h4 class="mb-2 mt-1">
            <feather-icon
              icon="SettingsIcon"
              size="18"
              class="mr-1"
            />
            Configuración Comercial
          </h4>

          <b-row>
            <b-col cols="12">
              <b-form-group
                v-if="isAdmin"
                label="Ruta"
                label-for="input-customer-route"
              >
                <div class="d-flex align-items-start">
                  <div class="flex-grow-1">
                    <v-select
                      id="input-customer-route"
                      v-model="form.customer_route_id"
                      :options="customerRoutes"
                      label="name"
                      :reduce="route => route.id"
                      placeholder="Selecciona una ruta"
                      :clearable="true"
                    >
                      <template #option="{ name, user }">
                        <div>
                          <span>{{ name }}</span>
                          <small
                            v-if="user && user.name"
                            class="text-muted ml-1"
                          >— {{ user.name }}</small>
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    class="ml-1"
                    title="Nueva ruta"
                    @click="openRouteModal(null)"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                  <b-button
                    v-if="form.customer_route_id"
                    variant="outline-secondary"
                    size="sm"
                    class="ml-1"
                    title="Editar ruta"
                    @click="openRouteModal(selectedRoute)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                </div>
                <small class="text-muted">
                  El vendedor de la ruta se asignará automáticamente a este cliente.
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="d-flex mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
            >
              Crear
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
            >
              Limpiar
            </b-button>
          </div>

        </b-form>
      </validation-observer>

      <customer-route-form-modal
        :show.sync="routeModalVisible"
        :route="routeBeingEdited"
        @saved="onRouteSaved"
      />
    </template>
  </b-sidebar>
</template>

<script>
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import { required } from '@/utils/validations/validations'
import vSelect from 'vue-select'
import { isAdmin } from '@/utils/auth'
import Ripple from 'vue-ripple-directive'
import CustomerRouteFormModal from './CustomerRouteFormModal.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Cleave,
    vSelect,
    CustomerRouteFormModal,
  },

  directives: {
    Ripple,
  },

  props: {
    customerAddSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      required,
      priceLists: [],
      customerRoutes: [],
      isAdmin: false,
      routeModalVisible: false,
      routeBeingEdited: null,

      form: {
        name: '',
        nit: 'CF',
        nit_name: 'Consumidor Final',
        cellphone: '',
        phone: '',
        email: '',
        origin: '',
        customer_type: null,
        price_list_id: null,
        customer_route_id: null,
      },

      options: {
        cellphoneDelimiter: {
          delimiters: ['-'],
          blocks: [4, 4],
          uppercase: true,
        },
      },

      originOptions: [
        { value: '', text: 'Selecciona el origen' },
        { value: 'pagina_web', text: 'Página Web' },
        { value: 'redes_sociales', text: 'Redes Sociales' },
        { value: 'referido', text: 'Referido' },
        { value: 'evento', text: 'Evento' },
        { value: 'publicidad', text: 'Publicidad' },
        { value: 'otros', text: 'Otros' },
      ],

      customerTypeOptions: [
        { value: null, text: 'Selecciona el tipo de cliente' },
        { value: 'cliente_final', text: 'Cliente final' },
        { value: 'cliente_online', text: 'Cliente Online' },
        { value: 'excedentes', text: 'Excedentes' },
      ],
    }
  },

  computed: {
    selectedRoute() {
      return this.customerRoutes.find(r => r.id === this.form.customer_route_id) || null
    },
  },

  created() {
    this.isAdmin = isAdmin()
    this.loadPriceLists()
    if (this.isAdmin) {
      this.loadCustomerRoutes()
    }
  },

  methods: {
    loadPriceLists() {
      axios.get('price-list-active')
        .then(response => {
          this.priceLists = response.data.data
        })
        .catch(error => {
          this.showErrors(error)
        })
    },

    loadCustomerRoutes() {
      axios.get('customer-route-active')
        .then(response => {
          this.customerRoutes = response.data.data
        })
        .catch(error => {
          this.showErrors(error)
        })
    },

    openRouteModal(route) {
      this.routeBeingEdited = route
      this.routeModalVisible = true
    },

    onRouteSaved(savedRoute) {
      const idx = this.customerRoutes.findIndex(r => r.id === savedRoute.id)
      if (idx >= 0) this.$set(this.customerRoutes, idx, savedRoute)
      else this.customerRoutes.push(savedRoute)
      this.form.customer_route_id = savedRoute.id
    },

    changeNit() {
      if (this.form.nit === 'CF') {
        this.form.nit_name = 'Consumidor Final'
      } else {
        this.form.nit_name = this.form.name
      }
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          axios
            .post('customer', this.form)
            .then(response => {
              this.makeToast('success', 'Cliente agregado', `Se ha creado el cliente ${response.data.data.name}.`)
              this.$emit('refreshData')
              this.$emit('update:customer-add-sidebar-active', false)
              this.onReset()
            })
            .catch(error => {
              this.showErrors(error)
            })
        } else {
          this.makeToast('danger', 'Error', 'No es posible crear el cliente.')
        }
      })
    },

    onReset() {
      this.form.name = ''
      this.form.nit = 'CF'
      this.form.nit_name = 'Consumidor Final'
      this.form.cellphone = ''
      this.form.phone = ''
      this.form.email = ''
      this.form.origin = ''
      this.form.customer_type = null
      this.form.price_list_id = null
      this.form.customer_route_id = null
    },

    makeToast(variant = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .vs__selected {
  background-color: #838383 !important;
  border-color: #838383 !important;
  color: white !important;
  border-radius: 4px;
  padding: 0 8px;
}

::v-deep .vs__deselect {
  color: white !important;

  svg {
    fill: white;
    height: 12px;
    width: 12px;
  }
}

.content-sidebar-header {
  border-bottom: 1px solid #ebe9f1;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
